import React from "react";
import {Link} from "react-router-dom";

import ReactTable from "react-table";
import {Button} from "reactstrap";

import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import moment from "moment";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";



export default class Inventories extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Inventories._name, API.RequestType.READ_ALL);
		super(props, model);

	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 165,
				Cell: props => {
					return (
						<span>
							<Link to={`/products/inventories/${props.original._id}`}>
								<Button color="green-meadow" size={"sm"} block={true}>
									<i className={"fa fa-pencil"}/>View Inventory Count</Button>
							</Link>
						</span>
					);
				}
			},
			{
				Header: "Title",
				id: "title",
				accessor: obj => obj.title,
			},
			{
				Header: "Start",
				id: "start_date",
				width: 160,
				/**
				 *
				 * @param {Inventories_Object}obj
				 * @returns {string}
				 */
				accessor: obj => {
					return moment(obj.start_date)
						.local()
						.format("MM/DD/YYYY")
				}
			},
			{
				Header: "End",
				id: "end_date",
				width: 160,
				/**
				 *
				 * @param {Inventories_Object}obj
				 * @returns {string}
				 */
				accessor: obj => {
					return obj.end_date ? moment(obj.end_date)
						.local()
						.format("MM/DD/YYYY") : ''
				}
			},
			{
				Header: "Creator",
				id: "creator",
				accessor: obj => obj.creator ? obj.creator : 'Owner',
			},
			{
				Header: "Location",
				id: "location",
				accessor: obj => obj.locations? obj.locations.name : '',
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('Inventories', "")}
								{this.renderHeaderRight("Inventories", columns)}
							</div>
						</div>
						<ReactTable
							key={this.state.key}
							columns={columns}
							manual // Forces table not to paginate or sort automatically, so we can handle it server-side
							data={data}
							pages={pages} // Display the total number of pages
							loading={loading} // Display the loading overlay when we need it
							loadingText="Requesting Data"
							onFetchData={this.fetchData} // Request new data when things change
							onPageSizeChange={this.onPageSizeChange}
							onSortedChange={this.onSortedChange}
							page={this.state.page}
							onPageChange={this.onPageChange}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={true}
							showPaginationTop={false}
							showPaginationBottom={true}
							showPageSizeOptions={true}
							defaultPageSize={limit}
							pageSize={limit}
							pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		)
	}
}
